// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { FleetTracingRedirectAreaId } from './FleetTracingRedirectAreaId'
import {
  FleetTracingRedirectAreaNavigation,
  FleetTracingRedirectAreaNavigationIcon,
} from './FleetTracingRedirectAreaNavigation'
import { FleetTracingRedirectAreaRoutes } from './FleetTracingRedirectAreaRoutes'

const LazyFleetTracingRedirectComponent = lazy(
  () => import('./FleetTracingRedirectArea'),
)

const FleetTracingRedirectComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetTracingRedirectComponent />
  </SuspenseLoadingWrapper>
)

export const FleetTracingRedirectArea = {
  id: FleetTracingRedirectAreaId,
  Icon: FleetTracingRedirectAreaNavigationIcon,
  NavigationComponent: FleetTracingRedirectAreaNavigation,
  route: {
    path: FleetTracingRedirectAreaRoutes.route,
    component: FleetTracingRedirectComponent,
  },
}
